<template>
  <b-modal v-model="visible" size="sm" centered hide-footer
           :title="$t('privacyEye.protectedTitle')" @hidden="onHidden">
    <form @submit.prevent="submit">
      <label>{{ $t('privacyEye.enterPasswordPage') }}</label>
      <b-form-input type="password" v-model="password" autofocus
                    autocomplete="current-password"
                    :state="error ? false : null"/>
      <small v-if="error" class="text-danger">{{ $t('privacyEye.wrongPassword') }}</small>
      <div class="text-right mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-50" @click="visible = false">
          {{ $t('operations.cancel') }}
        </b-button>
        <b-button type="submit" variant="primary" size="sm" :disabled="busy || !password">
          <b-spinner small v-if="busy" class="mr-25"/>
          {{ $t('privacyEye.unlock') }}
        </b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

// Password gate for protected menu areas (affiliates / affiliate dashboards /
// lead distribution): the router guard aborts the navigation and stores the
// target route here; entering the ACCOUNT password (verified server-side)
// resumes the navigation.
export default {
  name: 'PasswordGateModal',
  data: () => ({
    visible: false,
    password: '',
    error: false,
    busy: false,
  }),
  computed: {
    ...mapGetters('securityGate', ['pendingRoute']),
  },
  watch: {
    pendingRoute(route) {
      if (route) {
        this.password = '';
        this.error = false;
        this.visible = true;
      }
    },
  },
  methods: {
    ...mapActions('dashboard', ['unlockDashboardAmounts']),
    ...mapMutations('securityGate', ['UNLOCK', 'CLEAR_PROMPT']),
    async submit() {
      if (!this.password || this.busy) return;
      this.busy = true;
      this.error = false;
      try {
        // Same server-side re-auth as the dashboards' privacy eye.
        await this.unlockDashboardAmounts({ password: this.password });
        const target = this.pendingRoute;
        this.UNLOCK();
        this.visible = false;
        if (target) {
          this.$router.push(target);
        }
      } catch (e) {
        this.error = true;
      } finally {
        this.busy = false;
        this.password = '';
      }
    },
    onHidden() {
      this.CLEAR_PROMPT();
    },
  },
};
</script>
